import generateHandleActions from 'redux/state-handler';
import { restApiStates } from 'redux/redux-actions';

const apiStates = [
  ...restApiStates(['users/broad-cast-groups'], 'userBroadCastGroups'),
  ...restApiStates(['users/broad-cast-group'], 'editBroadCastGroup'),
];

const instantStates = [];
const storage = {};
const listValues = ['userBroadCastGroups', 'editBroadCastGroups'];

export default generateHandleActions({ apiStates, instantStates, storage, listValues });
